module.exports = {
  footerText: 'Aköde © 2021',
}
